export const VehicleInfo = {
  yearList,
  makeList,
  findMakeId,
  findMake,
};

const VehicleMakeList = [
  { label: "Acura", code: 252 },
  { label: "Alfa Romeo", code: 291 },
  { label: "American Motors", code: 263 },
  { label: "Aston Martin", code: 359 },
  { label: "Audi", code: 266 },
  { label: "Bentley", code: 306 },
  { label: "BMW", code: 251 },
  { label: "Buick", code: 235 },
  { label: "Cadillac", code: 240 },
  { label: "Chevrolet", code: 230 },
  { label: "Chrysler", code: 241 },
  { label: "Daewoo", code: 269 },
  { label: "Daihatsu", code: 287 },
  { label: "Datsun", code: 261 },
  { label: "Dodge", code: 232 },
  { label: "Eagle", code: 271 },
  { label: "Ferrari", code: 289 },
  { label: "Fiat", code: 299 },
  { label: "Ford", code: 229 },
  { label: "Geo", code: 276 },
  { label: "GMC", code: 243 },
  { label: "Honda", code: 233 },
  { label: "Hummer", code: 297 },
  { label: "Hyundai", code: 253 },
  { label: "Infiniti", code: 257 },
  { label: "Isuzu", code: 250 },
  { label: "Jaguar", code: 259 },
  { label: "Jeep", code: 245 },
  { label: "Kia", code: 256 },
  { label: "Lamborghini ", code: 355 },
  { label: "Landcraft Corp/Landrover", code: 275 },
  { label: "Lexus", code: 254 },
  { label: "Lincoln", code: 244 },
  { label: "Maserati", code: 356 },
  { label: "Mazda", code: 239 },
  { label: "Mercedes-Benz", code: 247 },
  { label: "Mercury", code: 237 },
  { label: "MG", code: 278 },
  { label: "MINI", code: 364 },
  { label: "Mitsubishi", code: 242 },
  { label: "Nissan", code: 234 },
  { label: "Oldsmobile", code: 238 },
  { label: "Peugeot", code: 304 },
  { label: "Plymouth", code: 246 },
  { label: "Pontiac", code: 236 },
  { label: "Porsche", code: 265 },
  { label: "RAM", code: 360 },
  { label: "Renault", code: 298 },
  { label: "Rolls-Royce", code: 295 },
  { label: "Saab", code: 268 },
  { label: "Safari", code: 305 },
  { label: "Saturn", code: 248 },
  { label: "Scion", code: 354 },
  { label: "Studebaker", code: 333 },
  { label: "Subaru", code: 260 },
  { label: "Suzuki", code: 262 },
  { label: "Tesla", code: 363 },
  { label: "Toyota", code: 231 },
  { label: "Volkswagen", code: 249 },
  { label: "Volvo", code: 255 },
  { label: "Yugo", code: 318 },
];

function makeList() {
  return VehicleMakeList;
}

function findMakeId(makeName) {
  let retMakeId = 0;
  let makeInfo = VehicleMakeList.filter((x) => x.label === makeName);
  if (makeInfo[0] !== undefined) {
    retMakeId = makeInfo[0].code;
  }
  return retMakeId;
}

function findMake(makeCode) {
  let retMake = "";
  let makeInfo = VehicleMakeList.filter((x) => x.code === makeCode);
  if (makeInfo[0] !== undefined) {
    retMake = makeInfo[0].label;
  }
  return retMake;
}

function yearList() {
  return [
    {
      label: (new Date().getFullYear() + 1).toString(),
      code: (new Date().getFullYear() + 1).toString(),
    },
    {
      label: new Date().getFullYear().toString(),
      code: new Date().getFullYear().toString(),
    },
    {
      label: (new Date().getFullYear() - 1).toString(),
      code: (new Date().getFullYear() - 1).toString(),
    },
    {
      label: (new Date().getFullYear() - 2).toString(),
      code: (new Date().getFullYear() - 2).toString(),
    },
    {
      label: (new Date().getFullYear() - 3).toString(),
      code: (new Date().getFullYear() - 3).toString(),
    },
    {
      label: (new Date().getFullYear() - 4).toString(),
      code: (new Date().getFullYear() - 4).toString(),
    },
    {
      label: (new Date().getFullYear() - 5).toString(),
      code: (new Date().getFullYear() - 5).toString(),
    },
    {
      label: (new Date().getFullYear() - 6).toString(),
      code: (new Date().getFullYear() - 6).toString(),
    },
    {
      label: (new Date().getFullYear() - 7).toString(),
      code: (new Date().getFullYear() - 7).toString(),
    },
    {
      label: (new Date().getFullYear() - 8).toString(),
      code: (new Date().getFullYear() - 8).toString(),
    },
    {
      label: (new Date().getFullYear() - 9).toString(),
      code: (new Date().getFullYear() - 9).toString(),
    },
    {
      label: (new Date().getFullYear() - 10).toString(),
      code: (new Date().getFullYear() - 10).toString(),
    },
    {
      label: (new Date().getFullYear() - 11).toString(),
      code: (new Date().getFullYear() - 11).toString(),
    },
    {
      label: (new Date().getFullYear() - 12).toString(),
      code: (new Date().getFullYear() - 12).toString(),
    },
    {
      label: (new Date().getFullYear() - 13).toString(),
      code: (new Date().getFullYear() - 13).toString(),
    },
    {
      label: (new Date().getFullYear() - 14).toString(),
      code: (new Date().getFullYear() - 14).toString(),
    },
    {
      label: (new Date().getFullYear() - 15).toString(),
      code: (new Date().getFullYear() - 15).toString(),
    },
    {
      label: (new Date().getFullYear() - 16).toString(),
      code: (new Date().getFullYear() - 16).toString(),
    },
    {
      label: (new Date().getFullYear() - 17).toString(),
      code: (new Date().getFullYear() - 17).toString(),
    },
    {
      label: (new Date().getFullYear() - 18).toString(),
      code: (new Date().getFullYear() - 18).toString(),
    },
    {
      label: (new Date().getFullYear() - 19).toString(),
      code: (new Date().getFullYear() - 19).toString(),
    },
    {
      label: (new Date().getFullYear() - 20).toString(),
      code: (new Date().getFullYear() - 20).toString(),
    },
    {
      label: (new Date().getFullYear() - 21).toString(),
      code: (new Date().getFullYear() - 21).toString(),
    },
    {
      label: (new Date().getFullYear() - 22).toString(),
      code: (new Date().getFullYear() - 22).toString(),
    },
    {
      label: (new Date().getFullYear() - 23).toString(),
      code: (new Date().getFullYear() - 23).toString(),
    },
    {
      label: (new Date().getFullYear() - 24).toString(),
      code: (new Date().getFullYear() - 24).toString(),
    },
    {
      label: (new Date().getFullYear() - 25).toString(),
      code: (new Date().getFullYear() - 25).toString(),
    },
  ];
}
